module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.42aa0db.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Bold.otf
// module id = /Gyn
// module chunks = 10